
























































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import { User, UserRoleId, UserRoleOption, UserRole } from '@/types/user';
import UsersService from '@/mixins/users.service';

@Component({
  mixins: [ UsersService ],
})
export default class UserModal extends Mixins(UsersService) {
  private valid: boolean = false;

  private iterator: string = '';

  private passwordValidation(value: string) {
    if (this.userForm.id) {
      return true;
    } else {
      return !!value || 'Password is required';
    }
  }

  private emailValidation(value: string) {
    if (!this.emailAvailable(value)) {
      return 'This email already exists';
    } else {
      return !!value || 'Email is required';
    }
  }

  private userNameValidation(value: string) {
    if (!this.userNameAvailable(value)) {
      return 'This User Name already exists';
    } else {
      return !!value || 'User Name is required';
    }
  }

  private updateRoleField(event: number[]) {
    this.updateFormField(event.map((eId: number) => ({id: eId})), 'roles');
  }

  private updateFormField(event: string | object[], field: string) {
    this.$store.commit('addEditUser/updateField', {[field]: event});
  }

  private emailFieldChanged(emailAddress: string): void {
    if (this.emailAvailable(emailAddress)) {
      this.updateFormField(emailAddress, 'email');
    }
  }

  private submitUserForm(): void {
    const id = this.userForm.id;
    request(id !== null && id !== undefined ? 'put' : 'post', `users${ id ? '/' + id : ''}`, {
      ...this.userForm,
      roles: this.userForm.roles.map((role: UserRole) => role.id),
      id: id ? id : undefined,
    })
    .then((response: AxiosResponse) => {
      this.$store.dispatch('users/updateUsers', {force: true})
        .then(() => this.closeModal());
    });
  }

  private deleteUser(): void {
    const id = this.userForm.id;
    request('delete', `users/${id}`)
    .then((response: AxiosResponse) => {
      this.$store.dispatch('users/updateUsers', {force: true})
        .then(() => this.closeModal());
    });
  }

  private emailAvailable(email: string): boolean {
    return !this.filteredUsers.some((user: any) => user.email === email);
  }

  get filteredUsers(): User[] {
    if (this.userForm.id) {
      return this.users.filter((user: any) => user.id !== this.userForm.id);
    } else {
      return this.users;
    }
  }

  private userNameAvailable(userName: string): boolean {
    return !this.filteredUsers.some((user: any) => user.userName === userName);
  }

  private closeModal(): void {
    this.valid = false;
    this.$store.dispatch('addEditUser/resetBuilder');
  }

  get userForm(): any {
    return this.$store.getters['addEditUser/form'];
  }

  get showModal(): boolean {
    return this.$store.getters['addEditUser/showModal'];
  }

}
